// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#custom-logo-container {
  margin: 0px auto;
}

#status {
  display: none !important;
}

#theme-transition-overlay {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: block;
  pointer-events: none;
}

#theme-transition-overlay-img {
  display: block;
  position: absolute;
}

.big-button {
  width: 100%;
  height: 40px;
  margin: 5px auto 0;
  color: white;
  background-color: var(--btn-bg-primary);
  border-radius: 8px;
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
}

.medium-button {
  width: 100%;
  height: 40px;
  margin: 10px auto 0;
  color: white;
  background-color: var(--btn-bg-primary);
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
}

.button-transitions {
  transition: all 0.3s ease-out;
}

.big-button:disabled,
.big-button[disabled],
.medium-button:disabled,
.medium-button[disabled] {
  cursor: not-allowed;
  background: var(--color-disabled-btn) !important;
  color: white !important;
}

@media (hover: hover) {
  .big-button:hover:enabled,
  .medium-button:hover:enabled {
    background-color: var(--color-disabled-btn) !important;
    color: white !important;
  }
}
.wrapping-box-container {
  transform: translate(0%, 0%) !important;
}

#custom-logo-container {
  margin: 20px auto;
}

#custom-logo-container img {
  max-height: 50px;
  width: auto;
  height: auto;
  text-align: center;
  position: relative;
  padding-right: 4px;
}

button:disabled {
  cursor: not-allowed;
  color: white;
  border-color: transparent;
}

button::-moz-focus-inner {
  border: 0;
}

a {
  text-decoration: none;
  color: inherit;
}

/** Pseudo-Fullscreen Custom Activity Indicator Styles **/
.pseudo-fullscreen-activity-indicator-svg {
  animation: rotate 2s linear infinite;
}

.pseudo-fullscreen-activity-indicator-svg .path {
  stroke: var(--bg-dark-blue);
  stroke-width: 4;
  stroke-linecap: round;
  fill: none;
  animation: stretch-stroke 1.5s ease-in-out infinite;
}

.path {
  stroke: var(--bg-dark-blue);
  stroke-width: 4;
  stroke-linecap: round;
  fill: none;
  animation: stretch-stroke 1.5s ease-in-out infinite;
}

.pseudo-fullscreen-activity-indicator-svg__offwhite {
  animation: rotate 2s linear infinite;
}

.pseudo-fullscreen-activity-indicator-svg__offwhite .path {
  stroke: white;
  stroke-width: 4;
  stroke-linecap: round;
  fill: none;
  animation: stretch-stroke 1.5s ease-in-out infinite;
}

#DOM_FT_idScanReticleMessage {
  color: white !important;
  font-size: 18px !important;
  font-weight: 500 !important;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes stretch-stroke {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -135;
  }
}
/** Pseudo-Fullscreen Custom Result Animation Styles */
.pseudo-fullscreen-success-svg,
.pseudo-fullscreen-unsuccess-svg,
.pseudo-fullscreen-success-svg__offwhite,
.pseudo-fullscreen-unsuccess-svg__offwhite {
  border-radius: 50%;
  transform: translateZ(0);
}

.pseudo-fullscreen-success-svg .circlePath,
.pseudo-fullscreen-unsuccess-svg .circlePath,
.pseudo-fullscreen-success-svg__offwhite .circlePath,
.pseudo-fullscreen-unsuccess-svg__offwhite .circlePath {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
  animation: reveal-stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards, pseudo-fullscreen-circle-fill 0.3s ease-in-out 0.3s forwards;
}

.pseudo-fullscreen-success-svg .circlePath,
.pseudo-fullscreen-unsuccess-svg .circlePath {
  stroke: rgb(43, 43, 43);
}

.pseudo-fullscreen-success-svg__offwhite .circlePath,
.pseudo-fullscreen-unsuccess-svg__offwhite .circlePath {
  stroke: rgb(238, 246, 248);
}

.pseudo-fullscreen-success-svg .checkmarkPath,
.pseudo-fullscreen-unsuccess-svg .crossPath1,
.pseudo-fullscreen-unsuccess-svg .crossPath2,
.pseudo-fullscreen-success-svg__offwhite .checkmarkPath,
.pseudo-fullscreen-unsuccess-svg__offwhite .crossPath1,
.pseudo-fullscreen-unsuccess-svg__offwhite .crossPath2 {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
}

.pseudo-fullscreen-success-svg .checkmarkPath,
.pseudo-fullscreen-success-svg__offwhite .checkmarkPath {
  stroke: rgb(59, 195, 113);
}

.pseudo-fullscreen-unsuccess-svg .crossPath1,
.pseudo-fullscreen-unsuccess-svg .crossPath2,
.pseudo-fullscreen-unsuccess-svg__offwhite .crossPath1,
.pseudo-fullscreen-unsuccess-svg__offwhite .crossPath2 {
  stroke: rgb(195, 72, 59);
}

.pseudo-fullscreen-success-svg .checkmarkPath,
.pseudo-fullscreen-success-svg__offwhite .checkmarkPath {
  animation: reveal-stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;
}

.pseudo-fullscreen-unsuccess-svg .crossPath1,
.pseudo-fullscreen-unsuccess-svg__offwhite .crossPath1 {
  animation: reveal-stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;
}

.pseudo-fullscreen-unsuccess-svg .crossPath2,
.pseudo-fullscreen-unsuccess-svg__offwhite .crossPath2 {
  animation: reveal-stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;
}

@keyframes reveal-stroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes pseudo-fullscreen-circle-fill {
  100% {
    stroke-width: 52;
  }
}
/** Well-Rounded Custom Activity Indicator Styles */
.well-rounded-activity-indicator-svg .circleTrackPath {
  stroke: rgb(230, 230, 230);
  stroke-width: 6;
  fill: none;
}

.well-rounded-activity-indicator-svg .circleFillPath {
  stroke: transparent;
  stroke-width: 1;
  fill: rgb(9, 181, 163);
}

/** Well-Rounded Custom Result Animation Styles */
.well-rounded-success-svg,
.well-rounded-unsuccess-svg {
  border-radius: 50%;
  transform: translateZ(0);
}

.well-rounded-success-svg .circlePath,
.well-rounded-unsuccess-svg .circlePath {
  stroke: rgb(230, 230, 230);
  stroke-width: 6;
  fill: none;
}

.well-rounded-success-svg .checkmarkPath,
.well-rounded-unsuccess-svg .crossPath1,
.well-rounded-unsuccess-svg .crossPath2 {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
}

.well-rounded-success-svg .checkmarkPath {
  stroke: rgb(9, 181, 163);
  animation: reveal-stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;
}

.well-rounded-unsuccess-svg .crossPath1,
.well-rounded-unsuccess-svg .crossPath2 {
  stroke: rgb(230, 230, 230);
}

.well-rounded-unsuccess-svg .crossPath1 {
  animation: reveal-stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;
}

.well-rounded-unsuccess-svg .crossPath2 {
  animation: reveal-stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;
}

/** eKYC Custom Activity Indicator Animation Styles */
.ekyc-activity-indicator-svg .circlePath1 {
  fill: #c77174;
}

.ekyc-activity-indicator-svg .circlePath2 {
  fill: #d4595d;
}

.ekyc-activity-indicator-svg .circlePath3 {
  fill: #e03c41;
}

.ekyc-activity-indicator-svg .circlePath4 {
  fill: #ed1c24;
}

/** eKYC Custom Result Animation Styles */
.ekyc-success-svg,
.ekyc-unsuccess-svg,
.ekyc-success-svg__white,
.ekyc-unsuccess-svg__white {
  border-radius: 50%;
  transform: translateZ(0) scale(0, 0);
  transform-origin: 50% 50%;
  animation: ekyc-scale-to-default 0.5s cubic-bezier(0.65, 0, 0.45, 1) 0.3s forwards;
}

.ekyc-success-svg .checkmarkPath__back,
.ekyc-success-svg__white .checkmarkPath__back {
  animation: ekyc-scale-and-fade-out-success 0.5s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

.ekyc-unsuccess-svg .crossPath1__back,
.ekyc-unsuccess-svg .crossPath2__back,
.ekyc-unsuccess-svg__white .crossPath1__back,
.ekyc-unsuccess-svg__white .crossPath2__back {
  animation: ekyc-scale-and-fade-out-unsuccess 0.5s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

.ekyc-success-svg .checkmarkPath__back,
.ekyc-success-svg .checkmarkPath__front,
.ekyc-unsuccess-svg .crossPath1__back,
.ekyc-unsuccess-svg .crossPath2__back,
.ekyc-unsuccess-svg .crossPath1__front,
.ekyc-unsuccess-svg .crossPath2__front,
.ekyc-success-svg__white .checkmarkPath__back,
.ekyc-success-svg__white .checkmarkPath__front,
.ekyc-unsuccess-svg__white .crossPath1__back,
.ekyc-unsuccess-svg__white .crossPath2__back,
.ekyc-unsuccess-svg__white .crossPath1__front,
.ekyc-unsuccess-svg__white .crossPath2__front {
  transform-origin: 50% 50%;
  stroke-width: 8;
  stroke-linecap: square;
  fill: none;
}

.ekyc-success-svg .checkmarkPath__back,
.ekyc-success-svg .checkmarkPath__front,
.ekyc-unsuccess-svg .crossPath1__back,
.ekyc-unsuccess-svg .crossPath2__back,
.ekyc-unsuccess-svg .crossPath1__front,
.ekyc-unsuccess-svg .crossPath2__front {
  stroke: black;
}

.ekyc-success-svg__white .checkmarkPath__back,
.ekyc-success-svg__white .checkmarkPath__front,
.ekyc-unsuccess-svg__white .crossPath1__back,
.ekyc-unsuccess-svg__white .crossPath2__back,
.ekyc-unsuccess-svg__white .crossPath1__front,
.ekyc-unsuccess-svg__white .crossPath2__front {
  stroke: white;
}

@keyframes ekyc-scale-to-default {
  100% {
    transform: translateZ(0) scale(1, 1);
  }
}
@keyframes ekyc-scale-and-fade-out-success {
  100% {
    transform: scale(1.5, 1.5);
    opacity: 0;
    stroke: rgb(28, 237, 125);
  }
}
@keyframes ekyc-scale-and-fade-out-unsuccess {
  100% {
    transform: scale(1.5, 1.5);
    opacity: 0;
    stroke: rgb(237, 28, 36);
  }
}
.loading-session-token-container {
  position: absolute;
  top: 185px;
  width: 100%;
  display: block;
  z-index: 1;
}

@media screen and (max-width: 800px) {
  .loading-session-token-container {
    top: auto !important;
    transform: translateY(-50%);
  }
}
#loading-session-token-text {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  color: rgb(64, 127, 178);
}

.display-none {
  display: none;
}

.audit-trail-overlay {
  position: fixed;
  width: inherit;
  height: inherit;
  z-index: 1000;
  align-self: center;
}

.audit-trail-image {
  max-width: 200px;
  max-height: auto;
}

#additional-screen {
  display: block;
  opacity: 0;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
}

#additional-screen button {
  min-height: 50px;
  height: 50px;
  width: 320px;
  border: unset;
  margin: 0 auto -75px;
}

#additional-screen-logo {
  height: 70px;
}

#additional-screen-image-and-text > h2 {
  font-size: 20px;
  color: var(--bg-dark-blue);
}

#additional-screen-text {
  font-size: 16px;
  color: var(--bg-dark-blue);
}

/* FOOTER STYLING */
footer {
  position: absolute;
  bottom: 4px;
  width: 100%;
  font-size: 15px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
}

footer span p {
  margin: 0;
  color: grey;
}

.footer-element-margin {
  margin: 5px 0 5px;
}

footer span p a:hover {
  color: var(--bg-dark-blue);
  text-decoration: underline;
}

.hr {
  margin: 5px auto;
  width: 250px;
  border: none;
  height: 2px;
  background: #eee;
}

#copy-right-section {
  height: auto;
  display: block;
}

#copy-right-length {
  position: absolute;
  visibility: hidden;
  height: auto;
  width: auto;
  white-space: nowrap;
  font-size: 7px;
}

#DOM_FT_idScanRetakeButton,
#DOM_FT_idScanCaptureButton,
#DOM_FT_idScanAcceptButton,
#DOM_FT_idScanContinueButton,
#DOM_FT_ocrActionButton {
  align-items: center !important;
  justify-content: center !important;
}

#DOM_FT_idScanSelectionScreenInnerMiddleContainer h2,
#DOM_FT_cameraPermissionsInnerContainer h2 {
  font-size: 20px !important;
  font-weight: 700 !important;
  line-height: normal !important;
}
#DOM_FT_idScanSelectionScreenInnerMiddleContainer p,
#DOM_FT_cameraPermissionsInnerContainer p {
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: normal !important;
}
#DOM_FT_idScanSelectionScreenInnerMiddleContainer p span,
#DOM_FT_cameraPermissionsInnerContainer p span {
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: normal !important;
  display: block !important;
}
#DOM_FT_idScanSelectionScreenInnerMiddleContainer img,
#DOM_FT_cameraPermissionsInnerContainer img {
  height: 80px !important;
  width: 80px !important;
}

#DOM_FT_idScanSelectionMessage {
  margin: 0px !important;
}

#DOM_FT_idScanBrandingImage {
  display: none !important;
}

#DOM_FT_mainInterfaceNonOverlayContainer {
  width: inherit;
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/styles/styleFacetec.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,oBAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;;;;EAIE,mBAAA;EACA,gDAAA;EACA,uBAAA;AACF;;AAEA;EAEE;;IAEE,sDAAA;IACA,uBAAA;EAAF;AACF;AAGA;EACE,uCAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AADF;;AAIA;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;AADF;;AAIA;EACE,SAAA;AADF;;AAIA;EACE,qBAAA;EACA,cAAA;AADF;;AAIA,yDAAA;AACA;EACE,oCAAA;AADF;;AAIA;EACE,2BAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,mDAAA;AADF;;AAIA;EACE,2BAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,mDAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,mDAAA;AADF;;AAIA;EACE,uBAAA;EACA,0BAAA;EACA,2BAAA;AADF;;AAIA;EACE;IACE,yBAAA;EADF;AACF;AAIA;EACE;IACE,wBAAA;IACA,oBAAA;EAFF;EAKA;IACE,yBAAA;IACA,sBAAA;EAHF;EAMA;IACE,yBAAA;IACA,uBAAA;EAJF;AACF;AAOA,sDAAA;AAEA;;;;EAIE,kBAAA;EACA,wBAAA;AANF;;AASA;;;;EAIE,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,UAAA;EACA,mIAAA;AANF;;AASA;;EAEE,uBAAA;AANF;;AASA;;EAEE,0BAAA;AANF;;AASA;;;;;;EAME,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,UAAA;AANF;;AASA;;EAEE,yBAAA;AANF;;AASA;;;;EAIE,wBAAA;AANF;;AASA;;EAEE,0EAAA;AANF;;AASA;;EAEE,0EAAA;AANF;;AASA;;EAEE,0EAAA;AANF;;AASA;EACE;IACE,oBAAA;EANF;AACF;AASA;EACE;IACE,gBAAA;EAPF;AACF;AAWA,mDAAA;AAEA;EACE,0BAAA;EACA,eAAA;EACA,UAAA;AAVF;;AAaA;EACE,mBAAA;EACA,eAAA;EACA,sBAAA;AAVF;;AAcA,iDAAA;AAEA;;EAEE,kBAAA;EACA,wBAAA;AAZF;;AAeA;;EAEE,0BAAA;EACA,eAAA;EACA,UAAA;AAZF;;AAeA;;;EAGE,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,UAAA;AAZF;;AAeA;EACE,wBAAA;EACA,0EAAA;AAZF;;AAeA;;EAEE,0BAAA;AAZF;;AAeA;EACE,0EAAA;AAZF;;AAeA;EACE,0EAAA;AAZF;;AAgBA,qDAAA;AAEA;EACE,aAAA;AAdF;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EACE,aAAA;AAdF;;AAkBA,yCAAA;AAEA;;;;EAIE,kBAAA;EACA,oCAAA;EACA,yBAAA;EACA,kFAAA;AAhBF;;AAmBA;;EAEE,4FAAA;AAhBF;;AAmBA;;;;EAIE,8FAAA;AAhBF;;AAmBA;;;;;;;;;;;;EAYE,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,UAAA;AAhBF;;AAmBA;;;;;;EAME,aAAA;AAhBF;;AAmBA;;;;;;EAME,aAAA;AAhBF;;AAmBA;EACE;IACE,oCAAA;EAhBF;AACF;AAmBA;EACE;IACE,0BAAA;IACA,UAAA;IACA,yBAAA;EAjBF;AACF;AAoBA;EACE;IACE,0BAAA;IACA,UAAA;IACA,wBAAA;EAlBF;AACF;AAqBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;AAnBF;;AAsBA;EACE;IACE,oBAAA;IACA,2BAAA;EAnBF;AACF;AAsBA;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,wBAAA;AApBF;;AAuBA;EACE,aAAA;AApBF;;AAuBA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,gBAAA;EACA,gBAAA;AApBF;;AAuBA;EACE,cAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;AApBF;;AAuBA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;AApBF;;AAuBA;EACE,YAAA;AApBF;;AAuBA;EACE,eAAA;EACA,0BAAA;AApBF;;AAuBA;EACE,eAAA;EACA,0BAAA;AApBF;;AAuBA,mBAAA;AAEA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;AArBF;;AAwBA;EACE,SAAA;EACA,WAAA;AArBF;;AAwBA;EACE,iBAAA;AArBF;;AAwBA;EACE,0BAAA;EACA,0BAAA;AArBF;;AAwBA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,YAAA;EACA,cAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AArBF;;AAwBA;;;;;EAKE,8BAAA;EACA,kCAAA;AArBF;;AA0BE;;EACE,0BAAA;EACA,2BAAA;EACA,8BAAA;AAtBJ;AAyBE;;EACE,0BAAA;EACA,2BAAA;EACA,8BAAA;AAtBJ;AAwBI;;EACE,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,yBAAA;AArBN;AAyBE;;EACE,uBAAA;EACA,sBAAA;AAtBJ;;AA0BA;EACE,sBAAA;AAvBF;;AA0BA;EACE,wBAAA;AAvBF;;AA0BA;EACE,cAAA;AAvBF","sourcesContent":["#custom-logo-container {\n  margin: 0px auto;\n}\n\n#status {\n  display: none !important;\n}\n\n#theme-transition-overlay {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: block;\n  pointer-events: none;\n}\n\n#theme-transition-overlay-img {\n  display: block;\n  position: absolute;\n}\n\n.big-button {\n  width: 100%;\n  height: 40px;\n  margin: 5px auto 0;\n  color: white;\n  background-color: var(--btn-bg-primary);\n  border-radius: 8px;\n  font-size: 20px;\n  font-weight: 500;\n  cursor: pointer;\n  outline: none;\n}\n\n.medium-button {\n  width: 100%;\n  height: 40px;\n  margin: 10px auto 0;\n  color: white;\n  background-color: var(--btn-bg-primary);\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  outline: none;\n}\n\n.button-transitions {\n  transition: all 0.3s ease-out;\n}\n\n.big-button:disabled,\n.big-button[disabled],\n.medium-button:disabled,\n.medium-button[disabled] {\n  cursor: not-allowed;\n  background: var(--color-disabled-btn) !important;\n  color: white !important;\n}\n\n@media (hover: hover) {\n\n  .big-button:hover:enabled,\n  .medium-button:hover:enabled {\n    background-color: var(--color-disabled-btn) !important;\n    color: white !important;\n  }\n}\n\n.wrapping-box-container {\n  transform: translate(0%, 0%) !important;\n}\n\n#custom-logo-container {\n  margin: 20px auto;\n}\n\n#custom-logo-container img {\n  max-height: 50px;\n  width: auto;\n  height: auto;\n  text-align: center;\n  position: relative;\n  padding-right: 4px;\n}\n\nbutton:disabled {\n  cursor: not-allowed;\n  color: white;\n  border-color: transparent;\n}\n\nbutton::-moz-focus-inner {\n  border: 0;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n/** Pseudo-Fullscreen Custom Activity Indicator Styles **/\n.pseudo-fullscreen-activity-indicator-svg {\n  animation: rotate 2s linear infinite;\n}\n\n.pseudo-fullscreen-activity-indicator-svg .path {\n  stroke: var(--bg-dark-blue);\n  stroke-width: 4;\n  stroke-linecap: round;\n  fill: none;\n  animation: stretch-stroke 1.5s ease-in-out infinite;\n}\n\n.path {\n  stroke: var(--bg-dark-blue);\n  stroke-width: 4;\n  stroke-linecap: round;\n  fill: none;\n  animation: stretch-stroke 1.5s ease-in-out infinite;\n}\n\n.pseudo-fullscreen-activity-indicator-svg__offwhite {\n  animation: rotate 2s linear infinite;\n}\n\n.pseudo-fullscreen-activity-indicator-svg__offwhite .path {\n  stroke: white;\n  stroke-width: 4;\n  stroke-linecap: round;\n  fill: none;\n  animation: stretch-stroke 1.5s ease-in-out infinite;\n}\n\n#DOM_FT_idScanReticleMessage {\n  color: white !important;\n  font-size: 18px !important;\n  font-weight: 500 !important;\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes stretch-stroke {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -135;\n  }\n}\n\n/** Pseudo-Fullscreen Custom Result Animation Styles */\n\n.pseudo-fullscreen-success-svg,\n.pseudo-fullscreen-unsuccess-svg,\n.pseudo-fullscreen-success-svg__offwhite,\n.pseudo-fullscreen-unsuccess-svg__offwhite {\n  border-radius: 50%;\n  transform: translateZ(0);\n}\n\n.pseudo-fullscreen-success-svg .circlePath,\n.pseudo-fullscreen-unsuccess-svg .circlePath,\n.pseudo-fullscreen-success-svg__offwhite .circlePath,\n.pseudo-fullscreen-unsuccess-svg__offwhite .circlePath {\n  stroke-dasharray: 166;\n  stroke-dashoffset: 166;\n  stroke-width: 4;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  fill: none;\n  animation: reveal-stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards, pseudo-fullscreen-circle-fill .3s ease-in-out .3s forwards;\n}\n\n.pseudo-fullscreen-success-svg .circlePath,\n.pseudo-fullscreen-unsuccess-svg .circlePath {\n  stroke: rgb(43, 43, 43);\n}\n\n.pseudo-fullscreen-success-svg__offwhite .circlePath,\n.pseudo-fullscreen-unsuccess-svg__offwhite .circlePath {\n  stroke: rgb(238, 246, 248);\n}\n\n.pseudo-fullscreen-success-svg .checkmarkPath,\n.pseudo-fullscreen-unsuccess-svg .crossPath1,\n.pseudo-fullscreen-unsuccess-svg .crossPath2,\n.pseudo-fullscreen-success-svg__offwhite .checkmarkPath,\n.pseudo-fullscreen-unsuccess-svg__offwhite .crossPath1,\n.pseudo-fullscreen-unsuccess-svg__offwhite .crossPath2 {\n  transform-origin: 50% 50%;\n  stroke-dasharray: 48;\n  stroke-dashoffset: 48;\n  stroke-width: 4;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  fill: none;\n}\n\n.pseudo-fullscreen-success-svg .checkmarkPath,\n.pseudo-fullscreen-success-svg__offwhite .checkmarkPath {\n  stroke: rgb(59, 195, 113);\n}\n\n.pseudo-fullscreen-unsuccess-svg .crossPath1,\n.pseudo-fullscreen-unsuccess-svg .crossPath2,\n.pseudo-fullscreen-unsuccess-svg__offwhite .crossPath1,\n.pseudo-fullscreen-unsuccess-svg__offwhite .crossPath2 {\n  stroke: rgb(195, 72, 59);\n}\n\n.pseudo-fullscreen-success-svg .checkmarkPath,\n.pseudo-fullscreen-success-svg__offwhite .checkmarkPath {\n  animation: reveal-stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;\n}\n\n.pseudo-fullscreen-unsuccess-svg .crossPath1,\n.pseudo-fullscreen-unsuccess-svg__offwhite .crossPath1 {\n  animation: reveal-stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;\n}\n\n.pseudo-fullscreen-unsuccess-svg .crossPath2,\n.pseudo-fullscreen-unsuccess-svg__offwhite .crossPath2 {\n  animation: reveal-stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;\n}\n\n@keyframes reveal-stroke {\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n\n@keyframes pseudo-fullscreen-circle-fill {\n  100% {\n    stroke-width: 52;\n  }\n}\n\n\n/** Well-Rounded Custom Activity Indicator Styles */\n\n.well-rounded-activity-indicator-svg .circleTrackPath {\n  stroke: rgb(230, 230, 230);\n  stroke-width: 6;\n  fill: none;\n}\n\n.well-rounded-activity-indicator-svg .circleFillPath {\n  stroke: transparent;\n  stroke-width: 1;\n  fill: rgb(9, 181, 163);\n}\n\n\n/** Well-Rounded Custom Result Animation Styles */\n\n.well-rounded-success-svg,\n.well-rounded-unsuccess-svg {\n  border-radius: 50%;\n  transform: translateZ(0);\n}\n\n.well-rounded-success-svg .circlePath,\n.well-rounded-unsuccess-svg .circlePath {\n  stroke: rgb(230, 230, 230);\n  stroke-width: 6;\n  fill: none;\n}\n\n.well-rounded-success-svg .checkmarkPath,\n.well-rounded-unsuccess-svg .crossPath1,\n.well-rounded-unsuccess-svg .crossPath2 {\n  transform-origin: 50% 50%;\n  stroke-dasharray: 48;\n  stroke-dashoffset: 48;\n  stroke-width: 4;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  fill: none;\n}\n\n.well-rounded-success-svg .checkmarkPath {\n  stroke: rgb(9, 181, 163);\n  animation: reveal-stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;\n}\n\n.well-rounded-unsuccess-svg .crossPath1,\n.well-rounded-unsuccess-svg .crossPath2 {\n  stroke: rgb(230, 230, 230);\n}\n\n.well-rounded-unsuccess-svg .crossPath1 {\n  animation: reveal-stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;\n}\n\n.well-rounded-unsuccess-svg .crossPath2 {\n  animation: reveal-stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) 0.6s forwards;\n}\n\n\n/** eKYC Custom Activity Indicator Animation Styles */\n\n.ekyc-activity-indicator-svg .circlePath1 {\n  fill: #c77174;\n}\n\n.ekyc-activity-indicator-svg .circlePath2 {\n  fill: #d4595d;\n}\n\n.ekyc-activity-indicator-svg .circlePath3 {\n  fill: #e03c41;\n}\n\n.ekyc-activity-indicator-svg .circlePath4 {\n  fill: #ed1c24;\n}\n\n\n/** eKYC Custom Result Animation Styles */\n\n.ekyc-success-svg,\n.ekyc-unsuccess-svg,\n.ekyc-success-svg__white,\n.ekyc-unsuccess-svg__white {\n  border-radius: 50%;\n  transform: translateZ(0) scale(0, 0);\n  transform-origin: 50% 50%;\n  animation: ekyc-scale-to-default 0.5s cubic-bezier(0.65, 0, 0.45, 1) 0.3s forwards;\n}\n\n.ekyc-success-svg .checkmarkPath__back,\n.ekyc-success-svg__white .checkmarkPath__back {\n  animation: ekyc-scale-and-fade-out-success 0.5s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;\n}\n\n.ekyc-unsuccess-svg .crossPath1__back,\n.ekyc-unsuccess-svg .crossPath2__back,\n.ekyc-unsuccess-svg__white .crossPath1__back,\n.ekyc-unsuccess-svg__white .crossPath2__back {\n  animation: ekyc-scale-and-fade-out-unsuccess 0.5s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;\n}\n\n.ekyc-success-svg .checkmarkPath__back,\n.ekyc-success-svg .checkmarkPath__front,\n.ekyc-unsuccess-svg .crossPath1__back,\n.ekyc-unsuccess-svg .crossPath2__back,\n.ekyc-unsuccess-svg .crossPath1__front,\n.ekyc-unsuccess-svg .crossPath2__front,\n.ekyc-success-svg__white .checkmarkPath__back,\n.ekyc-success-svg__white .checkmarkPath__front,\n.ekyc-unsuccess-svg__white .crossPath1__back,\n.ekyc-unsuccess-svg__white .crossPath2__back,\n.ekyc-unsuccess-svg__white .crossPath1__front,\n.ekyc-unsuccess-svg__white .crossPath2__front {\n  transform-origin: 50% 50%;\n  stroke-width: 8;\n  stroke-linecap: square;\n  fill: none;\n}\n\n.ekyc-success-svg .checkmarkPath__back,\n.ekyc-success-svg .checkmarkPath__front,\n.ekyc-unsuccess-svg .crossPath1__back,\n.ekyc-unsuccess-svg .crossPath2__back,\n.ekyc-unsuccess-svg .crossPath1__front,\n.ekyc-unsuccess-svg .crossPath2__front {\n  stroke: black;\n}\n\n.ekyc-success-svg__white .checkmarkPath__back,\n.ekyc-success-svg__white .checkmarkPath__front,\n.ekyc-unsuccess-svg__white .crossPath1__back,\n.ekyc-unsuccess-svg__white .crossPath2__back,\n.ekyc-unsuccess-svg__white .crossPath1__front,\n.ekyc-unsuccess-svg__white .crossPath2__front {\n  stroke: white;\n}\n\n@keyframes ekyc-scale-to-default {\n  100% {\n    transform: translateZ(0) scale(1, 1);\n  }\n}\n\n@keyframes ekyc-scale-and-fade-out-success {\n  100% {\n    transform: scale(1.5, 1.5);\n    opacity: 0;\n    stroke: rgb(28, 237, 125);\n  }\n}\n\n@keyframes ekyc-scale-and-fade-out-unsuccess {\n  100% {\n    transform: scale(1.5, 1.5);\n    opacity: 0;\n    stroke: rgb(237, 28, 36);\n  }\n}\n\n.loading-session-token-container {\n  position: absolute;\n  top: 185px;\n  width: 100%;\n  display: block;\n  z-index: 1;\n}\n\n@media screen and (max-width: 800px) {\n  .loading-session-token-container {\n    top: auto !important;\n    transform: translateY(-50%);\n  }\n}\n\n#loading-session-token-text {\n  position: relative;\n  left: 50%;\n  transform: translateX(-50%);\n  color: rgb(64, 127, 178);\n}\n\n.display-none {\n  display: none;\n}\n\n.audit-trail-overlay {\n  position: fixed;\n  width: inherit;\n  height: inherit;\n  z-index: 1000;\n  align-self: center;\n}\n\n.audit-trail-image {\n  max-width: 200px;\n  max-height: auto;\n}\n\n#additional-screen {\n  display: block;\n  opacity: 0;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n#additional-screen button {\n  min-height: 50px;\n  height: 50px;\n  width: 320px;\n  border: unset;\n  margin: 0 auto -75px;\n}\n\n#additional-screen-logo {\n  height: 70px;\n}\n\n#additional-screen-image-and-text>h2 {\n  font-size: 20px;\n  color: var(--bg-dark-blue);\n}\n\n#additional-screen-text {\n  font-size: 16px;\n  color: var(--bg-dark-blue);\n}\n\n/* FOOTER STYLING */\n\nfooter {\n  position: absolute;\n  bottom: 4px;\n  width: 100%;\n  font-size: 15px;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n}\n\nfooter span p {\n  margin: 0;\n  color: grey;\n}\n\n.footer-element-margin {\n  margin: 5px 0 5px;\n}\n\nfooter span p a:hover {\n  color: var(--bg-dark-blue);\n  text-decoration: underline;\n}\n\n.hr {\n  margin: 5px auto;\n  width: 250px;\n  border: none;\n  height: 2px;\n  background: #eee;\n}\n\n#copy-right-section {\n  height: auto;\n  display: block;\n}\n\n#copy-right-length {\n  position: absolute;\n  visibility: hidden;\n  height: auto;\n  width: auto;\n  white-space: nowrap;\n  font-size: 7px;\n}\n\n#DOM_FT_idScanRetakeButton,\n#DOM_FT_idScanCaptureButton,\n#DOM_FT_idScanAcceptButton,\n#DOM_FT_idScanContinueButton,\n#DOM_FT_ocrActionButton {\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n#DOM_FT_idScanSelectionScreenInnerMiddleContainer,\n#DOM_FT_cameraPermissionsInnerContainer {\n  h2 {\n    font-size: 20px !important;\n    font-weight: 700 !important;\n    line-height: normal !important;\n  }\n\n  p {\n    font-size: 16px !important;\n    font-weight: 400 !important;\n    line-height: normal !important;\n\n    span {\n      font-size: 16px !important;\n      font-weight: 400 !important;\n      line-height: normal !important;\n      display: block !important;\n    }\n  }\n\n  img {\n    height: 80px !important;\n    width: 80px !important;\n  }\n}\n\n#DOM_FT_idScanSelectionMessage {\n  margin: 0px !important;\n}\n\n#DOM_FT_idScanBrandingImage {\n  display: none !important;\n}\n\n#DOM_FT_mainInterfaceNonOverlayContainer {\n  width: inherit;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
